import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Work } from './components/Work';
import { Services } from './components/Services';
import { About } from './components/About';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { StructuredData } from './components/StructuredData';
export function App() {
  return <div className="w-full min-h-screen bg-cream text-ink font-sans selection:bg-accent selection:text-cream" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Work data-id="element-4" />
        <Services data-id="element-5" />
        <About data-id="element-6" />
        <Process data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FAQ data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <StructuredData data-id="element-12" />
    </div>;
}